var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{staticClass:"mx-auto",staticStyle:{"height":"100%","width":"auto","max-width":"100%"},attrs:{"src":require('../assets/vendoorr_logo.jpeg'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }